












































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
@Component
export default class InputSerial extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: "" }) title: String;
  @Prop({ type: String, default: "" }) skuCode: String;
  @Prop({ type: String, default: "" }) storageType: String;
  serial: String = "";
  qty: String = "";

  closePopupInput() {
    this.serial = "";
    this.qty = "";
    this.$emit("save-success");
    this.$emit("input", false);
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
      //Focus input code of page
      (this.$parent.$refs.txtInputCode as any).focus();
    } else {
      if (this.storageType == "N_SRL") {
        this.onFucusQty();
      }

      if (this.storageType == "SRL") {
        this.onFucusSerial();
      }
    }
  }

  onFucusQty() {
    Vue.nextTick().then(() => {
      let focusQty = <HTMLInputElement>this.$refs.inputQty;
      focusQty.focus();
    });
  }

  onFucusSerial() {
    Vue.nextTick().then(() => {
      let focusSerial = <HTMLInputElement>this.$refs.inputSerial;
      focusSerial.focus();
    });
  }

  async pushItem() {
    const qty = this.storageType === "SRL" ? 1 : this.qty;
    if (qty < 0) {
      this.$Message.error(Util.L("Error.InputQtyGreaterThanZero"));
      return;
    }

    await this.$store
      .dispatch({
        type: "packing/pushItem",
        data: {
          previousCode: this.storageType === "SRL" ? this.skuCode.trim() : "",
          qty: this.storageType === "SRL" ? 1 : this.qty,
          code:
            this.storageType === "SRL"
              ? this.serial.trim()
              : this.skuCode.trim(),
        },
      })
      .then(() => {
        this.closePopupInput();
      });
  }
}
